import { Box, Button, Dialog, DialogContent } from "@mui/material";
import { useState } from "react";
import Splitter from "../sign-in-splitter/Splitter";
// import { ReactComponent as CloseDialog } from "../../assets/images/close.svg";
import SignUp from "../sign-up/Sign-up";
import VerifyOtp from "../verify-otp/VerifyOtp";
import CloseIcon from "@mui/icons-material/Close";


const SignUpDialog = ({ open, onClose }) => {
  // const [isOtpPage, setIsOtpPage] = useState(false);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: "700px",
          height: "700px",
          borderRadius: "10px",
          overflow: "hidden",
        },
      }}
    >
      <DialogContent sx={{ p: 0, height: "100%", overflow: "hidden" }}>
        <Box className="auth-dialog">
          {/* LEFT – SPLITTER */}
          <Box className="auth-left">
            <Splitter variant="signup" />
          </Box>

          {/* RIGHT – FORM */}
          <Box className="auth-right">
            <Button
              onClick={onClose}
              sx={{
                position: "absolute",
                top: 12,
                right: 12,
                minWidth: "auto",
                width: 36,
                height: 36,
                borderRadius: "50%",
                color: "#555",
                zIndex: 1,
                "&:hover": { backgroundColor: "#f0f0f0" },
              }}
            >
              <CloseIcon fontSize="small" />
            </Button>
            <SignUp
              onClose={onClose}
            // setIsOtpPage={setIsOtpPage}
            />
            {/* {!isOtpPage && (
              <SignUp
                onClose={onClose}
              // setIsOtpPage={setIsOtpPage}
              />
            )} */}

            {/* {isOtpPage && (
              <VerifyOtp
                onClose={onClose}
                setIsOtpPage={setIsOtpPage}
              />
            )} */}
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SignUpDialog;
